export const PKG_VERSION = process.env.PKG_VERSION || '';
export const PKG_NAME = process.env.PKG_NAME || '';
export const URL_PREFIX = process.env.URL_PREFIX || '';
export const SOCKET_PREFIX = process.env.SOCKET_PREFIX || '';
